export default __webpack_public_path__ + "static/fresh_full-2d24440f6dc0244367b3e0645149dad2.jpg";